import { SecurityConstants } from 'src/app/security/constants/security-constants';
import { Routes, RouterModule, CanActivate } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { RoleGuard } from 'src/app/guards/role.guard';
import { SecureComponent } from './secure.component';
import { CanDeactivateContractGuard } from 'src/app/guards/can-deactivate.guard';

const secureRoutes: Routes = [
  {
    path: 'app', component: SecureComponent, canActivate: [AuthGuard],
    // canActivate: [AuthGuard, RoleGuard],
    // data: {
    //   roles: [
    //     SecurityConstants.ADMINISTRATOR_ROLE,
    //     SecurityConstants.USER_ROLE,
    //   ],
    // },
    children: [
      { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard-pages/dashboard-pages.module').then((x) => x.DashboardPagesModule),
      },
      {
        path: 'contract',
        loadChildren: () => import('./contract-pages/contract-pages.module').then((x) => x.ContractPagesModule),
      },
      {
        path: 'account',
        loadChildren: () => import('./account-pages/account-pages.module').then((x) => x.AccountPagesModule),
      },
    ],
  }
];

export const SECURE_ROUTES = RouterModule.forChild(secureRoutes);
